const UPDATE_NAME_DELAY = 500;

export { UPDATE_NAME_DELAY };
